import * as actionTypes from '../../../../models/actionTypes';
import { FreelanceRequest } from '../../models/requestModels';

export const searchRequests = () => {
  return {
    type: actionTypes.SEARCH_REQUESTS,
  };
};

export const searchRequestsSuccess = (requests: FreelanceRequest[]) => {
  return {
    type: actionTypes.SEARCH_REQUESTS_SUCCESS,
    requests,
  };
};

export const searchRequestsError = () => {
  return {
    type: actionTypes.SEARCH_REQUESTS_ERROR,
  };
};

export const getRequest = (requestId: string) => {
  return {
    type: actionTypes.GET_REQUEST,
    requestId,
  };
};

export const getRequestSuccess = (request: FreelanceRequest) => {
  return {
    type: actionTypes.GET_REQUEST_SUCCESS,
    request,
  };
};

export const getRequestError = () => {
  return {
    type: actionTypes.GET_REQUEST_ERROR,
  };
};
